import { Button } from '@usealloy/component-library';
import styled, { css, keyframes } from 'styled-components';

export const gentleBlinking = keyframes`
  0% {
    opacity: 0.6;
  }
  25% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
  75% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
`;

export const Caret = styled.div`
  position: relative;
  top: 0;
  left: 0;
  display: flex;
  flex-shrink: 0;
  max-width: 4px;
  min-height: 25px;
  background: var(--cl-yellow-200);
  border-radius: var(--cl-radius-1);
  transition: all 200ms ease;
  animation: ${gentleBlinking} 3000ms ease infinite;

  &:focus-within {
    position: relative;
    right: 0;
    min-width: 4px;
    max-width: 1000px;
  }
`;

export const HiddenCaret = styled.div<{
  inlineSuggestion?: boolean;
  isClosingSuggestion?: boolean;
}>`
  position: absolute;
  top: 0;
  left: -5px;
  display: flex;
  flex-shrink: 0;
  width: 12px;
  height: 25px;
  border-radius: var(--cl-radius-1);
  caret-color: transparent;
  align-items: center;

  &:hover {
    background: var(--cl-yellow-300);
    animation: ${gentleBlinking} 3000ms ease infinite;
  }

  ${({
    inlineSuggestion, isClosingSuggestion,
  }) => inlineSuggestion && css`
    cursor: pointer;
    position: relative;
    right: 0;
    left: 0;
    background: var(--cl-yellow-300);
    color: var(--cl-text-default);
    font-family: var(--cl-font-family-mono);
    font-size: var(--cl-font-size-2);
    font-weight: bold;
    margin: 0 3px;
    ${isClosingSuggestion && css`
      animation: ${gentleBlinking} 1000ms ease infinite;
      left: -5px;
    `}
  `}
`;

export const HoverButton = styled(Button)`
  && {
    visibility: hidden;
    color: var(--cl-gray-500);
    font-family: var(--cl-font-family-mono);
    font-size: var(--cl-font-size-2);
    font-weight: var(--cl-font-weight-medium);
    padding: 0;
  }
`;
